module.exports = __webpack_public_path__ + "static/media/Xerneas_gaussian2.4b4bbe3a.png";